export const DEFAULT_BUSINESS_ALIGNMENT = {
  departmentAgencies: "",
  naicsCodes: "",
  contractTypes: [],
  setAsides: [],
  classificationCodes: null,
  subTiers: null,
  offices: null,
  placeOfPerformance: null,
  officeLocation: null,
};
